import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import useIsMobile from 'utils/hooks/useIsMobile';

import './Layout.scss';

/**
 * Layout da tela Weol-SM (FE-WINDX-018).
 *
 * Renderiza sub-tabs Semanal/Comparativo como **navegacao secundaria**
 * (links com sublinhado na rota ativa) — propositadamente distinto do
 * <TabbedPage> usado no top-level (<WindxWrapper>), evitando dois niveis
 * de tabs visualmente iguais.
 *
 * Hierarquia visual:
 *   <WindxWrapper> (top-level — TabbedPage azul, abas grandes):
 *     [WEOL-SH]  [WEOL-SM]
 *                    \
 *                     <SemanalLayout> (sub-nav — links com sublinhado):
 *                       Semanal | Comparativo
 *                              \
 *                               <Outlet /> -> Semanal | Comparativo
 *
 * Detecao de rota via <NavLink> nativo do react-router (atributo `end` no
 * link de `/windx/semanal` para nao casar com sub-rotas).
 */
export default function WindxSemanalLayout() {
  const isMobile = useIsMobile();

  return (
    <div className="windx-semanal-layout">
      <nav
        className={`windx-sub-nav${isMobile ? ' windx-sub-nav--mobile' : ''}`}
        aria-label="Sub-tabs Weol-SM"
      >
        <NavLink to="/windx/automatic/semanal" end className="windx-sub-nav__link">
          Semanal
        </NavLink>
        <NavLink to="/windx/automatic/semanal/comparativo" className="windx-sub-nav__link">
          Comparativo
        </NavLink>
      </nav>

      <div className="windx-sub-nav__content">
        <Outlet />
      </div>
    </div>
  );
}
